/**
 * @generated SignedSource<<c03adee97079403443a00dbe40c5d6c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UploadModal_createMeetingRecordingFromUploadMutation$variables = {
  addToChannels?: ReadonlyArray<string> | null;
  addToMeeting?: string | null;
  language: string;
  title: string;
  uploadedFileKey: string;
};
export type UploadModal_createMeetingRecordingFromUploadMutation$data = {
  readonly createMeetingRecordingFromUpload: {
    readonly account: {
      readonly " $fragmentSpreads": FragmentRefs<"UploadModal_RemainingUploadCredits_account">;
    };
    readonly meetingRecording: {
      readonly id: string;
    };
  } | null;
};
export type UploadModal_createMeetingRecordingFromUploadMutation = {
  response: UploadModal_createMeetingRecordingFromUploadMutation$data;
  variables: UploadModal_createMeetingRecordingFromUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addToChannels"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addToMeeting"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uploadedFileKey"
},
v5 = [
  {
    "kind": "Variable",
    "name": "addToChannels",
    "variableName": "addToChannels"
  },
  {
    "kind": "Variable",
    "name": "addToMeeting",
    "variableName": "addToMeeting"
  },
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  },
  {
    "kind": "Variable",
    "name": "title",
    "variableName": "title"
  },
  {
    "kind": "Variable",
    "name": "uploadedFileKey",
    "variableName": "uploadedFileKey"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadModal_createMeetingRecordingFromUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "CreateMeetingRecordingFromUpload",
        "kind": "LinkedField",
        "name": "createMeetingRecordingFromUpload",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UploadModal_RemainingUploadCredits_account"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UploadModal_createMeetingRecordingFromUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "CreateMeetingRecordingFromUpload",
        "kind": "LinkedField",
        "name": "createMeetingRecordingFromUpload",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionState",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionBillingCycleAnchor",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountUploadCredits",
                "kind": "LinkedField",
                "name": "uploadCredits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includedUploadCredits",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includedCreditsUsedCurrentCycle",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "81bac390380f967b39cdd2ee667395a4",
    "id": null,
    "metadata": {},
    "name": "UploadModal_createMeetingRecordingFromUploadMutation",
    "operationKind": "mutation",
    "text": "mutation UploadModal_createMeetingRecordingFromUploadMutation(\n  $title: String!\n  $language: String!\n  $uploadedFileKey: String!\n  $addToMeeting: ID\n  $addToChannels: [ID!]\n) {\n  createMeetingRecordingFromUpload(title: $title, language: $language, uploadedFileKey: $uploadedFileKey, addToMeeting: $addToMeeting, addToChannels: $addToChannels) {\n    meetingRecording {\n      __typename\n      id\n    }\n    account {\n      ...UploadModal_RemainingUploadCredits_account\n      id\n    }\n  }\n}\n\nfragment UploadModal_RemainingUploadCredits_account on Account {\n  billingAccount {\n    subscriptionState\n    subscriptionBillingCycleAnchor\n    id\n  }\n  uploadCredits {\n    includedUploadCredits\n    includedCreditsUsedCurrentCycle\n  }\n}\n"
  }
};
})();

(node as any).hash = "f148f1cb5eec595ef499a00695eedc0e";

export default node;
